import { StoreFont, StoreSpecialFont } from '@/types';

export const isStoreFont = (font: StoreFont | StoreSpecialFont): font is StoreFont =>
  font.type === 'sprd';
